// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text.info[data-v-73b3b7a2]{display:flex;align-items:center}.text.info>span[data-v-73b3b7a2]{margin-right:5px}", ""]);
// Exports
module.exports = exports;
